import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from '../../../core/services/alert.service';
import { SessionService } from 'src/app/core/services/session.service';
import { BehaviorSubject } from 'rxjs';
import { CountdownComponent, CountdownConfig, CountdownEvent } from 'ngx-countdown';
// import { CommonService } from 'src/app/core/services/common.service';

@Component({
  standalone: false,
  selector: 'app-timeout',
  templateUrl: './timeout.component.html',
  // styleUrls: ['./timeout.component.scss']
  host: {
    '[class.card]': `true`,
    '[class.text-center]': `true`,
    '[class.bold]': `true`,
  },
  styles: [
    `
      :host ::ng-deep .custom-style {
        font-size: 18px;
        .item {
          padding-left: 4px;
          &:nth-child(1) {
            color: rgb(199, 66, 0);
          }
          &:nth-child(2) {
            color: rgb(45, 0, 170);
          }
          &:nth-child(3) {
            color: rgb(207, 7, 147);
          }
        }
      }
    `,
  ],
})
export class TimeoutComponent implements OnInit {
  @ViewChild('cd', { static: false }) private countdown: CountdownComponent;
  config: CountdownConfig = { leftTime: 300, notify: [1] };
  remainingMinutes: BehaviorSubject<number>;
  remainingSeconds: BehaviorSubject<number>;
  remainingHours: BehaviorSubject<number>;
  loginExpired: boolean = false;
  constructor(
    public sessionService: SessionService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
    this.countdown.begin();
  }

  handleEvent(e: CountdownEvent) {
    if (e.action === 'notify') {
      this.loginExpired = true;
    }
    // if (this.loginExpired) {
    //   this.logout();
    // }
  }

  toNumber(value: any): number {
    return Number(value);
  }

  getValue(Value: any) {
    return Value.getValue();
  }

  refreshToken() {
    this.sessionService.refreshToken();
    this.activeModal.close('Cross click');

  }

  logout() {
    this.activeModal.close('Cross click');
    this.sessionService.logOut();
  }

}
